import IncomeTaxComputation from "./MyPay/IncomeTax/IncomeTax";
import MySalary from "./MyPay/MySalary/MySalary";
import PayslipComponent from "./MyPay/PaySlips/PaySlip";
import FinanceSummary from "./Summary/Summary";


export const MyFinanceRoutes = {
    FinanceSummary,
    MySalary,
    PayslipComponent,
    IncomeTaxComputation
}